export default __webpack_public_path__ + "static/media/introduction-background.52f4d37c.mp4";